import { safeCallSegment } from '../helpers';

export function trackUpdateCompanyAdmin(payload: { email: string; companyId: string; companyName: string }): void {
  safeCallSegment(() => {
    analytics.track('Updated Company Admin ', payload);
  });
}

export function trackCompanyDetailsProvided(company: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('Company details provided', {
      company
    });
  });
}
